import { Link, Skeleton } from '@benchlabs/react-design-system';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useFetchServiceInstructions } from '../bench-services-api/useFetchGlobalServiceInstruction';
import { ReactElement } from 'react';
import React from 'react';
import { useFetchBusinessService } from '../bench-services-api/useFetchBusinessService';

type ServiceInstructionLinkProps = {
  addOnId: string | undefined;
  clientId: number;
};

const queryClient = new QueryClient(); // move to global area when we convert over more MFEs

export const ServiceInstructionLink: ({
  addOnId,
  clientId,
}: ServiceInstructionLinkProps) => ReactElement = (props): ReactElement => (
  <QueryClientProvider client={queryClient}>
    <ServiceInstructionLinkContent {...props} />
  </QueryClientProvider>
);

export const ServiceInstructionLinkContent = (props: ServiceInstructionLinkProps) => {
  const { addOnId, clientId } = props;
  if (!addOnId) throw new Error('Missing required param addOnId');

  const { data: businessService, status } = useFetchBusinessService({
    addOnId,
  });

  if (status === 'loading') return <Skeleton variant="rounded" width="100%" />;

  if (!businessService?.globalServiceId) {
    return (
      <>
        <Link href={`/app/${clientId}/ledger-accounts?tab=ADDONS`} target="_blank">
          Update the data source and action for more help.
        </Link>
      </>
    );
  }

  return <ServiceInstructionsLoader globalServiceId={businessService?.globalServiceId} />;
};

type ServiceInstructionsLoaderProps = {
  globalServiceId: string;
};

const ServiceInstructionsLoader = (props: ServiceInstructionsLoaderProps) => {
  const { globalServiceId } = props;

  const { data: globalServiceInstructions, status } = useFetchServiceInstructions({
    globalServiceId,
  });

  if (status === 'loading') return <Skeleton variant="rounded" width="100%" />;
  if (status === 'error') return <>Unable to load instructions for this task.</>;
  if (!globalServiceInstructions?.length) return <>No help is available for the task.</>;

  return (
    <>
      {globalServiceInstructions.map(instruction => (
        <Link
          key={instruction.instructionId}
          href={instruction.url}
          target="_blank"
          sx={{ display: 'block', mt: 1 }}
        >
          Need help with this task?
        </Link>
      ))}
    </>
  );
};
